import { AlertOutlined, PlayCircleFilled, StopFilled } from "@ant-design/icons"
import { Popover, Tag, Typography } from "antd"
import moment from "moment"

const { Text } = Typography

export const endDate = (value, record) => {
  if (record.doneByRewinder) {
    const popoverContent = (
      <div>
        <p>Date: {moment.unix(value.seconds).format("DD.MM.YYYY")}</p>
        <p>Time: {moment.unix(value.seconds).format("HH:mm:ss")}</p>
      </div>
    )

    return (
      <Popover content={popoverContent} title="Time">
        <Tag icon={<StopFilled />} color="#2f54eb">
          {moment.unix(value.seconds).format("DD.MM.YYYY")}
        </Tag>
      </Popover>
    )
  } else if (record.selectedProduct.machine === "Tape") {
    // Specific case handling for "Tape" machine type without `doneByWinder`
    const popoverContent = (
      <div>
        <p>Date: {moment.unix(record.doneByTape.seconds).format("DD.MM.YYYY")}</p>
        <p>Time: {moment.unix(record.doneByTape.seconds).format("HH:mm:ss")}</p>
      </div>
    )
    return (
      <Popover content={popoverContent} title="Time">
        <Tag icon={<StopFilled />} color="#2f54eb">
          {moment.unix(record.doneByTape.seconds).format("DD.MM.YYYY")}
        </Tag>
      </Popover>
    )
  } else {
    // General fallback for records without `doneByWinder`
    return <Text>Error</Text>
    // <Text>No data</Text>
  }
}

export const startDate = (value, record) => {
  // Define the content of your Popover here. It could be a component, JSX, or text.
  const popoverContent = (
    <div>
      <p>Date: {moment.unix(value.seconds).format("DD.MM.YYYY")}</p>
      <p>Time: {moment.unix(value.seconds).format("HH:mm:ss")}</p>
    </div>
  )

  return (
    <>
      <Popover content={popoverContent} title="Time">
        <Tag icon={<PlayCircleFilled />} color="#13c2c2">
          {moment.unix(value.seconds).format("DD.MM.YYYY")}
        </Tag>
      </Popover>
    </>
  )
}

export const dueDateTag = (value) => {
  // Get the due date using moment.unix so that it matches your other functions
  const due = moment.unix(value.seconds)
  // Set today as start of day for proper day comparison.
  const today = moment().startOf("day")
  // Use red if due date is today or earlier, green otherwise.
  const color = due.isSameOrBefore(today, "day") ? "#FF0000" : "#87d068"

  // Calculate the day difference. If due date is past, diffDays will be positive.
  const diffDays = moment().diff(due, "days")
  let diffText = ""
  if (diffDays > 0) {
    diffText = `Overdue by ${diffDays} day${diffDays > 1 ? "s" : ""}`
  } else if (diffDays < 0) {
    diffText = `Due in ${Math.abs(diffDays)} day${Math.abs(diffDays) > 1 ? "s" : ""}`
  } else {
    diffText = "Due today"
  }

  const popoverContent = (
    <div>
      <p>Date: {due.format("DD.MM.YYYY")}</p>
      <Text style={{ color: "#FF0000" }}>{diffText}</Text>
    </div>
  )

  return (
    <Popover content={popoverContent} title="Due Date">
      <Tag color={color}>
        {due.format("DD.MM.YYYY")}
        {diffDays >= 0 && <AlertOutlined style={{ marginLeft: 2 }} />}
      </Tag>
    </Popover>
  )
}
